// extracted by mini-css-extract-plugin
export default {"Title":"fPjTWxkR"};